"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseNavigationModule {
}
exports.FuseNavigationModule = FuseNavigationModule;
